import React,{useState} from 'react';
import styled from 'styled-components';
import {Link } from "react-router-dom";
import friend_check from '../../images/friend_check.png'
import appInfoContainer from '../../auth/appInfoContainer';



// 하단 모달 창 리스트 
let modallist = [
    {text:"친구 취소",color:"#de0000",} ,
  ]

export default function GroupFriend({index,receivedData,friendSubmit,display,name,dataSubmit,value,userInfo,currentPostIndex,setCurrentPostIndex,setModalOption,setModalShow,groupInfo}) {

   const init = () => {
     modallist[0].clickEvent = () =>{
         setModalShow(false); 
        };
   }
   init();
    function onClick(){
        friendSubmit(value.user_no)
        // setCurrentPostIndex()
    }
    function ClickModal(){
        setModalShow(true);
        setModalOption("friendcancel")
        // frienddeleteSubmit(value.user_no)
        setCurrentPostIndex(value.user_no)
    }
    function requestModal(){
        setModalShow(true);
        setModalOption("requestCancel")
        // frienddeleteSubmit(value.user_no)
        setCurrentPostIndex(value.user_no)
    }
    function friendsModal (){
        dataSubmit(value.user_no)
        // alert("수락")
        // setCurrentPostIndex(value.user_no)
    }
    // dot 버튼 눌렀을 때
    const openModal = () =>{
        setModalShow(true);
        setModalOption("forcedExit")
        setCurrentPostIndex(value.user_no)
    }
    
    const friendactive = () =>{
        if(value.is_friend)
            return <RemoveFriendButton click={ClickModal}/>
        else if(value.is_friend_requested_received === true)
            return <FriendButtonclick click={friendsModal}/>
        else if(value.is_friend_requested_received === false && value.is_friend_requested)
            return <SubmitFriendButton click={requestModal}  />
        else if(value.is_friend === false)
            return <AddFriendButton click={onClick}/> 
    }

    var userno = groupInfo.admins? groupInfo.admins[0].user_no : null

    return(
        <>
            <Div>
                <Ul>
                    <Li>
                        <Link component={A} to={`/task/friend/${value.user_no}/list`}>
                            <Images src={appInfoContainer.imagePath +"/user_profile_img/"+value.profile_img}/>
                        </Link> 
                        <Name>{value.nickname}</Name>
                    </Li>
                    <Li>
                        <b>
                            {
                                parseInt(value.user_no) === parseInt(userInfo.id) ? 
                                null
                                :
                                    // value.is_friend_requested ?
                                    // <RemoveFriendButton click={ClickModal}/>
                                    // :
                                    // <AddFriendButton click={onClick}/>
                                    friendactive()
                            }
                           
                        </b>
                        {   
                            parseInt(value.user_no) === parseInt(userInfo.id) ? 
                            null
                            :
                                parseInt(userInfo.id) === parseInt(userno)  ?
                                <Dot_bt onClick={openModal} display={display}><Dot></Dot></Dot_bt>
                                :
                                null
                        }
                            
        
                        
                    </Li>
                </Ul>
            </Div>
    </>
    )
    // <Friend_list name={props.nickname}  display={props.display}></Friend_list>;
}

function AddFriendButton({click}){
    return (
        <Button onClick={click}>
            <Plus_icon></Plus_icon>
            <Txt>친구</Txt>
        </Button>
    )
}


function RemoveFriendButton({click}){
    return (
        <Button2 onClick={click}>
            <Txt2>친구</Txt2>
            <Check><img src={friend_check}></img></Check>
        </Button2>
    )
}

function SubmitFriendButton({click,display}){
    return (
        <Button3 onClick={click} display={display}>
            <Txt2>요청중</Txt2>
        </Button3>
    )
}

function FriendButtonclick({click,display}){
    return (
        <Button3 onClick={click} display={display}>
            <Txt2>친구수락</Txt2>
        </Button3>
    )
}


// function FL() {
//     return <div style={styles.test}/>
// }


// let styles ={
//     test:{
//         backgroundColor:"grey",
//         width:200,
//         height:200,
//         margin:10,
//         paddingTop:10,
//     }
// }

const Images = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`
const Div = styled.div`
    padding: 0 calc(100vw*(22/375)); 0 calc(100vw*(17/375));
    margin-bottom : calc(100vw*(22/375));
`
const Ul = styled.ul`
    display: flex;
    align-items: center;
    justify-content: space-between;
`
const Li = styled.li`
    display:flex;
    align-items: center;
`
const A = styled.a`
    display:block;
    width: calc(100vw*(56/375));
    height: calc(100vw*(56/375));
    border-radius: 100%;
    overflow: hidden;
    border: solid calc(100vw*(1/375)) #c6c6c6;
`
const Name = styled.span`
    font-size: calc(100vw*(16/375));
    font-weight: 500;
    margin-left: calc(100vw*(11/375));
`
const Button = styled.button`
    width: calc(100vw*(67/375));
    height: calc(100vw*(27/375));
    border-radius: calc(100vw*(5/375));
    border: solid 1px #e6e6e6;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
`
const Button2 = styled(Button)`
    background-color: #4e4e4e;
`
const Button3 = styled.button`
    width: calc(100vw*(67/375));
    height: calc(100vw*(27/375));
    border-radius: calc(100vw*(5/375));
    // background-color: #ffffff;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    border: solid 1px #989898;
    // background-color: #ffffff;
    background-color: #989898;
`
const Plus_icon = styled.span`
    position: relative;
    display:block;
    width: calc(100vw*(8/375));
    height: calc(100vw*(1.3/375));
    background:#4e4e4e;
    margin-right: calc(100vw*(3/375));
    
    &::after {
        content:'';
        position: absolute;
        display:block;
        width: calc(100vw*(8/375));
        height: calc(100vw*(1.3/375));
        background:#4e4e4e;
        transform: rotate(90deg);
    }
`
const Txt = styled.span`
    font-size: calc(100vw*(12/375));
    font-weight: 500;
    color: #4e4e4e;
`
const Txt2 = styled(Txt)`
    color: #fff;
`
const Dot = styled.span`
    position:relative;
    display:block;
    width: calc(100vw*(4/375));
    height: calc(100vw*(4/375));
    background-color: #292724;
    border-radius:50%;
    margin-left: calc(100vw*(8/375));
    opacity: 0.4;

    &::before {
        content:'';
        position: absolute;
        width: calc(100vw*(4/375));
        height: calc(100vw*(4/375));
        background-color: #292724;
        border-radius:50%;
        top:calc(100vw*(6/375));
        left:0;
    }
    &::after {
        content:'';
        position: absolute;
        width: calc(100vw*(4/375));
        height: calc(100vw*(4/375));
        background-color: #292724;
        border-radius:50%;
        bottom:calc(100vw*(-12/375));
        left:0;
    }
`
const Dot_bt = styled.a`
    display: ${props=>props.display};
    width: 100%;
    height: calc(100vw*(17/375));
`

const Check = styled.p`
    width: calc(100vw*(10.2/375));
    height: calc(100vw*(7.9/375));
    margin-left: calc(100vw*(3/375));
`